var activateOpenFacets = (cookies, store) => store.state.sharedEnv.payload.mdmToggleOpenFacets === 'true' || !!(cookies && cookies.get('MDM_TOOGLE_OPENFACETS'));
export default activateOpenFacets;